module.exports = __webpack_public_path__ + "img/treatments-reservation.b22d32f4.svg";